<template>
  <v-container fluid>
    <v-card>
      <v-card-title>
        <slotbar fluid align='center' :slots='2' :slotWidth='300'>
          <template v-slot:slot1>
            <h1>Contactos</h1>
          </template>
          <template v-slot:slot2>
            <v-btn color="primary" @click="goFirmas()">Contratos <i class="mdi mdi-file-document"></i></v-btn>
          </template>
        </slotbar>
      </v-card-title>
      <v-card-text>
        <v-data-table
          :headers="headers"
          :items="contactos"
          :options.sync="options"
          :server-items-length="total"
          :footer-props='{
            itemsPerPageOptions: [10, 20, 50, 100]
          }'
          no-data-text="No hay contactos disponibles">
          <template v-slot:top>
            <slotbar fluid :slots='2' :slotWidth='400'>
              <template v-slot:slot1></template>
              <template v-slot:slot2>
                <addContacto @reload='onReload'></addContacto>
              </template>
            </slotbar>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
  import Vue from 'vue';
  import { ApiInit } from '@/api';
  // import { mapActions } from 'vuex';
  import addContacto from '@/components/contactos/addContacto.vue';
  import slotbar from '@/components/custom/slotbar.vue';
  import { consoleErrorMessage, toasterErrorMessage } from '@/utils/responseCatchMessages.js';
  export default {
    name: 'contactos',
    components:{
      addContacto,
      slotbar,
    },
    data: () => ({
      nombre: '',
      showCard: false,
      contactos: [],
      headers: [
        { text: 'Nombre', value: 'nombre'},
        { text: 'RFC', value: 'rfc'},
        { text: 'Correo', value: 'correo' },
        { text: 'SMS', value: 'sms'},
        { text: 'Razón social', value: 'razonSocial'},
      ],
      options: {
        itemsPerPage: 10,
        sortBy: ['id'],
        sortDesc: [true],
      },
      total: 0,
      firstLoad: true,
    }),
    computed: {
      isSortedById() {
        if (!Array.isArray(this.options.sortBy)) return false;
        if (this.options.sortBy.indexOf('id') === -1) return false;
        return true;
      },
      isSortedDesc() {
        if (!Array.isArray(this.options.sortDesc)) return false;
        if (this.options.sortDesc.indexOf(true) === -1) return false;
        return true;
      },
    },
    methods: {
      // ...mapActions(['addContacto', 'getContacto', 'listContactos']),
      goFirmas(){
        this.$router.push({ name: 'Contrato' });
      },
      /*
      async addContacto() {
        const defaultToastMessage = 'Error al agregar el contacto.';
        const defaultConsoleMessage = 'addContacto error';
        try {
          const result = await this.$store.dispatch('addContacto', this.nombre);
          if (result === null) {
            console.error(defaultConsoleMessage);
            this.$toast.error(defaultToastMessage);
            return;
          }
        } catch (e) {
          consoleErrorMessage(e, defaultConsoleMessage);
          toasterErrorMessage(this.$toast.error, e, defaultToastMessage);
        }
      },
      */
      onReload() {
        if (!this.isSortedById || !this.isSortedDesc) {
          this.options.sortBy = ['id'];
          this.options.sortDesc = [true];
        } else this.listContactos();
      },
      async listContactos() {
        const defaultToastMessage = 'Error al obtener la lista de contactos.';
        const defaultConsoleMessage = 'listContactos error';
        try {
          const clienteId = this.$store.getters.getClient;
          const options = this.options;
          const result = await this.$store.dispatch('listContactos', {clienteId, options});
          if (result === null) {
            console.error(defaultConsoleMessage);
            this.$toast.error(defaultToastMessage);
            return;
          }
          console.log("Contactos: %o", result);
          this.total = result.totalElements;
          this.contactos = result.content;
        } catch (e) {
          consoleErrorMessage(e, defaultConsoleMessage);
          toasterErrorMessage(this.$toast.error, e, defaultToastMessage);
        }
      },
    },
    watch: {
      options() {
        console.debug('watch options', JSON.parse(JSON.stringify(this.options)));
        if (this.firstLoad) {
          this.firstLoad = false;
          ApiInit().then(r => this.listContactos());
        } else this.listContactos();
      },
    },
  };
</script>

<style type="">
.contrato{
  margin-right: 145px;
  margin-left: 145px;
  border-color: green;
}
</style>
